import {Expressions} from '@packages/systems/wfdl';

import {
  isSliderSlide,
  isProjectingElement,
  isRichText,
  isFigure,
  isListItem,
  isSliderWrapper,
  isPaginationPrevious,
  isPaginationNext,
  isList,
  isFormForm,
} from '@packages/utilities/elementTypeUtils';

import {
  type Expression,
  type ExpressionElement,
} from '@packages/systems/wfdl-ast';

export const closestSliderSlide = (
  element: ExpressionElement,
  tree: Expression
): null | ExpressionElement => {
  return Expressions.closestElement(tree, element.id, isSliderSlide);
};
export const closestSliderWrapper = (
  element: ExpressionElement,
  tree: Expression
): null | ExpressionElement => {
  return Expressions.closestElement(tree, element.id, isSliderWrapper);
};

/**
 * Returns the closest ancestral element that is projecting element starting at the element of `id`.
 * If the element of `id` matches the predicate it will returned.
 */
export const getClosestProjectingElement = (
  rootElement: Expression,
  id: string
): ExpressionElement | null =>
  Expressions.closestElement(rootElement, id, isProjectingElement);

export function getClosestRichTextElement(
  rootElement: Expression,
  id: string
): ExpressionElement | null {
  return Expressions.closestElement(rootElement, id, isRichText);
}

export function getClosestFigureElement(
  rootElement: Expression,
  id: string
): ExpressionElement | null {
  return Expressions.closestElement(rootElement, id, isFigure);
}

export function getClosestListItemElement(
  rootElement: Expression,
  id: string
): ExpressionElement | null {
  return Expressions.closestElement(rootElement, id, isListItem);
}

export function getClosestListElement(
  rootElement: Expression,
  id: string
): ExpressionElement | null {
  return Expressions.closestElement(rootElement, id, isList);
}

/**
 * Returns the closest ancestral element that is a pagination previous element starting at the element with provided `id`.
 */
export function closestPaginationPrevious(
  rootElement: Expression,
  elementId: string
): ExpressionElement | null {
  return Expressions.closestElement(
    rootElement,
    elementId,
    isPaginationPrevious
  );
}

/**
 * Returns the closest ancestral element that is a pagination next element starting at the element with provided `id`.
 */
export function closestPaginationNext(
  rootElement: Expression,
  elementId: string
): ExpressionElement | null {
  return Expressions.closestElement(rootElement, elementId, isPaginationNext);
}

export function getClosestFormElement(
  rootElement: Expression,
  id: string
): ExpressionElement | null {
  return Expressions.closestElement(rootElement, id, isFormForm);
}
